import { NgModule } from '@angular/core';
import { TrustHtmlPipe } from './trust-html.pipe';



@NgModule({
  declarations: [
    TrustHtmlPipe
  ],
  exports: [
    TrustHtmlPipe
  ]
})
export class TrustHtmlModule { }
